import { PaymentOption } from '../../store/purchase';

export const AvailablePaymentOptions: Record<string, PaymentOption> = {
  APPLE_PAY: 'Apple Pay',
  CREDIT_CARD: 'Credit Card',
  PAYPAL: 'PayPal',
};
